import { isSSR } from '@pkgs/shared-client/helpers/dom';
import wrapDisplayName from '@pkgs/shared-client/helpers/wrapDisplayName';
import React, { useEffect, useState } from 'react';

const SVWithNoSSR = <P,>(WrappedComponent: React.ComponentType<P>) => {
	const SVWithNoSSR = (props: P) => {
		const [render, setRender] = useState(false);

		useEffect(() => {
			setRender(true);
		}, []);

		if (isSSR || !render) {
			return null;
		}

		return <WrappedComponent {...(props as P & JSX.IntrinsicAttributes)} />;
	};

	SVWithNoSSR.displayName = wrapDisplayName(WrappedComponent, 'SVWithNoSSR');

	return SVWithNoSSR;
};

export default SVWithNoSSR;
